/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';

import './Notifications.scss';
/**


@Author

@param

@return 

**/

export class Notifications extends Component {

    render() {
        return (
            <div className="notifications">
                <h4><b>This page is under construction</b></h4>
            </div>
        );
    }
}